module.exports = __webpack_public_path__ + "dancingscript-regular-webfont.e6dcf1330867845c46a8.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/src/assets/fonts/dancing/dancingscript-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/dancing/dancingscript-regular-webfont.woff2
// module chunks = 1